import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * `settings/Audit::prompts`, peste `AuditPromptsController` - briefingul
 * agentului, pe bucati. GET aduce ecranul, POST salveaza `block[cheie]` si
 * raspunde cu acelasi ecran, reincarcat, plus `saved`.
 */
export type PromptBlock = {
  key: string
  phase: string
  title: string
  /** De ce exista regula. Un editor care nu vede DE CE o sterge. */
  why: string
  /** Textul implicit, cu care se livreaza. */
  text: string
  /** Textul cu care se va rula chiar acum. */
  live: string
}

export type PromptPhase = { key: string; title: string; when: string; count: number }

export type PromptTrail = { key: string; title: string; where: string; who: string; changed_at: string }

export type AuditPrompts = {
  version: string
  typeId: number
  type: { id: number; title: string } | null
  types: { id: number; title: string }[]
  phases: PromptPhase[]
  blocks: PromptBlock[]
  /** cheie => 'this audit' | 'all audits' - blocurile rescrise in vigoare. */
  changed: Record<string, string>
  /** Rescrisuri ramase in urma: cheie => 'moved' | 'unknown'. */
  behind: Record<string, string>
  /** Rescrisuri care au pierdut un marcaj: cheie => marcajele pierdute. */
  lost: Record<string, string[]>
  ready: boolean
  saved: number
  trail: PromptTrail[]
  /** Amprenta briefingului; rularile o poarta. Egala cu `stock` = neschimbat. */
  fingerprint: string
  stock: string
}

export function auditPromptsQuery(type: number) {
  return queryOptions({
    queryKey: ['settings', 'audit', 'prompts', type],
    queryFn: () => apiGet<AuditPrompts>(`/settings/audit/prompts/${type}`),
    staleTime: 30_000,
  })
}

/** Salveaza blocurile date; o caseta lasata exact ca implicitul nu se stocheaza. */
export function savePrompts(type: number, blocks: Record<string, string>): Promise<AuditPrompts> {
  const fields: Record<string, PostValue> = {}
  for (const [key, body] of Object.entries(blocks)) fields[`block[${key}]`] = body
  return apiPost<AuditPrompts>(`/settings/audit/prompts/${type}`, fields)
}
